import { defineComponent as _defineComponent } from 'vue'
import CoordTypeCom from '@/components/coord-type/index.vue'
import { isEdit, isLogin, showToolbox } from '@/store/sys'
import { mapCompany } from '@/store/setup'
import download from './download.vue'
import Info from '@/components/info/index.vue'
import {
  customMap,
  useViewStack,
  customMouseMenuStack,
  useTransform,
  LocalCoord,
  normalizeCoord,
  RightMenuAtom,
  CoordinateType,
  getCoordLabel as getCoordLabelRaw,
  localCoordinate,
  useSDK,
  CoordOutType,
  coordOutTypeStack,
  useEdit,
  TLocalCoord,
  disableLaserModeStack,
  params
} from '@/hook'

import { Message } from '@kankan/components/src/expose-common'
import { copyText } from '@/utils'
import { computed, reactive, ref, watchEffect } from 'vue'
import { CoordType, Mode } from '@/sdk'
import { lang, langNameEum, ui18n } from '@/lang'
import { main, list } from '@/store/dataset'
import { unSetScene } from '@/store/controlPoint'
import router, { readyRouteName } from '@/router'
import { URL, axios } from '@/request'

import Label from '@/app/epoint/views/calibration/label/index.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const outType = ref<CoordOutType>(CoordOutType.LN)
const selectType = ref<CoordinateType | TLocalCoord>(LocalCoord.LOCAL)
const map = mapCompany.value === 'google' ? LocalCoord.GMap : LocalCoord.GDMap
const downMode = computed(
  () => isEdit.value && router.currentRoute.value.name === readyRouteName.coord
)

watchEffect(onCleanup => {
  if (Number(selectType.value) === CoordinateType.GIS) {
    onCleanup(coordOutTypeStack.push(outType))
  }
})

watchEffect(() => {
  if ([LocalCoord.LOCAL, map].includes(selectType.value as any)) {
    customMap.coord = selectType.value as any
  }
})

const getCoordLabel = (coordName: any) => {
  const coord = localCoordinate.find(coord => coord.value === coordName)
  if (coord?.label) {
    return coord?.label
  } else {
    return getCoordLabelRaw(coordName)
  }
}

useViewStack(() => {
  const atom: RightMenuAtom = reactive({
    color: '#fff',
    icon: 'copy',
    label: ui18n.t('coord.copy'),
    mapDisabled: true,
    click: async (pos, screen) => {
      let local = useTransform(
        LocalCoord.SCREEN,
        LocalCoord.LOCAL,
        screen,
        customMap.coordOutType
      )

      let mesh = useSDK().coordTransform(
        CoordType.LOCAL,
        local as any,
        CoordType.MESH_LOCAL,
        main.value.id
      )

      const info = useSDK().scene.getPointByScreen()
      const localPos = info
        ? {
            // ...sdk.coordTransform(
            //   CoordType.LOCAL,
            //   info.position,
            //   CoordType.MESH_LOCAL,
            //   info.datasetId
            // ),
            ...info.position
          }
        : null
      if (!localPos) return

      console.log(localPos)
      let ret = useTransform(
        LocalCoord.LOCAL,
        customMap.coord,
        localPos,
        customMap.coordOutType
      )
      console.log(
        useTransform(
          LocalCoord.LOCAL,
          '4547',
          localPos,
          // {
          //   x: 113.60608556676553,
          //   y: 22.381184919481697,
          //   z: 2.12127864774645
          // },
          customMap.coordOutType,undefined, undefined
        )
      )

      // if (customMap.coord === LocalCoord.LOCAL) {
      //   ret = useSDK().coordTransform(
      //     CoordType.MESH_LOCAL,
      //     ret as any,
      //     CoordType.LOCAL,
      //     useSDK().scene.getPointByScreen().datasetId
      //   )
      // }
      try {
        const data = normalizeCoord(ret, customMap.coord) as {}
        const str = Object.entries(data).reduce((t, c) => {
          t += `${c[0]}: ${c[1]}\n`
          return t
        }, '')
        await copyText(str)
        Message.success(ui18n.t('coord.copySuccess'))
      } catch (e) {
        Message.error(e.message)
      }
    }
  })
  const menus = ref([...customMouseMenuStack.current.value.value, atom])

  const quits = [
    // disableLaserModeStack.push(ref([Mode.gsmx])),
    customMouseMenuStack.push(menus)
  ]
  return () => {
    quits.forEach(fn => fn())
  }
})

if (params.test) {
  axios.post(URL.epControlPonts, {}).then(controls => {
    const laser = useSDK()
    const cts = controls.map(c => {
      const loc = laser.getPositionByPanoInfo(
        c.uid,
        c.offset.left,
        c.offset.top,
        c.offset.depth
      )
      laser.sceneCarry.use({
        component: Label,
        props: {
          show: true,
          text: '',
          pos: loc,
          focus: false,
          changePos() {}
        }
      })
      return loc
    })
    console.log('loc 0', cts)
  })
}

const __returned__ = { outType, selectType, map, downMode, getCoordLabel, CoordTypeCom, get isLogin() { return isLogin }, get showToolbox() { return showToolbox }, download, get customMap() { return customMap }, get LocalCoord() { return LocalCoord }, get CoordinateType() { return CoordinateType }, get CoordOutType() { return CoordOutType }, get useEdit() { return useEdit }, get unSetScene() { return unSetScene } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})